// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2goDB","containerItemsCenter":"Skeleton_containerItemsCenter__GzlPh"};